import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=190ef2c5&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=190ef2c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ef2c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190ef2c5')) {
      api.createRecord('190ef2c5', component.options)
    } else {
      api.reload('190ef2c5', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=190ef2c5&scoped=true&", function () {
      api.rerender('190ef2c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4pEkAqf7UlD84/JS/comp/PopupDialog.vue"
export default component.exports